import { FC } from 'react';

import Form from '@/shared/components/forms/PlatformForm';
import PlatformSelect from '@/shared/components/forms/PlatformSelect';

interface TagsProps {
    filters: Record<string, unknown>;
    handleChange: (path: string[], value: unknown) => void;
}

const Tags: FC<TagsProps> = ({ filters, handleChange }): JSX.Element => (
    <Form>
        <Form.Item label='Document Tags' style={{ marginBottom: 0 }}>
            <PlatformSelect
                allowClear
                mode='tags'
                onChange={(value) => handleChange(['tags'], value)}
                placeholder='Add Document Tags...'
                style={{ width: '100%' }}
                value={Array.isArray(filters.tags) ? filters.tags.map(String) : []}
            />
        </Form.Item>
    </Form>
);

export default Tags;
